import { useSelector } from "react-redux"

export const usePermission = (groupName, modeName) => {
  const accessModes = useSelector(state => state.auth.access_modes)
  const right = accessModes?.[groupName]?.[modeName]
  const readRight = !!right && right !== 'Нет'
  const updateRight = !!right && right === 'Полный'
  return { readRight, updateRight }
}

// Принимает список пар [groupName, modeName] и разрешает доступ, если есть право хотя бы по одной из них
export const usePermissionAny = (pairs) => {
  const accessModes = useSelector(state => state.auth.access_modes)
  const readRight = pairs.some(([groupName, modeName]) => {
    const right = accessModes?.[groupName]?.[modeName]
    return !!right && right !== 'Нет'
  })
  return { readRight }
}
